import Box from "@/common/components/Box"
import Button from "@/common/components/Button"
import TextField from "@/common/components/TextField"
import { ChevronsRight } from "lucide-react"
import { Link, useParams } from "react-router-dom"
import useEquipmentModel from "../../hooks/useEquipmentModel"
import GoBackButton from "@/common/components/GoBackButton";
import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper"

const Show = () => {
  const { id } = useParams();

  const {
    data: initialEquipment,
    isLoading,
    isPending,
    error: requestError = {} as any,
    refetch: refetchRequest,
  } = useEquipmentModel(id || '')

  const disableUpdateButton = isPending || requestError?.status === 403;

  return (
    <div >
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-2 items-center">
          <GoBackButton fallback="/equipment-models" searchLastRouteFromFallback />
          <p className="text-white-400 font-normal">Modelos de equipamentos</p>
          <ChevronsRight color='#ffffffb3' />
          <h2>{initialEquipment?.display_name}</h2>
        </div>

        {!initialEquipment?.fipe_code &&
          <Link to={`/equipment-models/${id}/edit`}>
            <Button
              name="access_equipment_models_show"
              operationKlassToCheckPermission="Admin::EquipmentModels::Update"
              type="submit"
              className="shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]"
              disabled={disableUpdateButton}
            >
              Editar
            </Button>
          </Link>
        }

      </div>
      {isLoading
        ? (
          <Box>Carregando...</Box>
        )
        : (
          <ErrorMessageWrapper
            className="max-h-[calc(100vh-128px)]"
            statusCode={requestError?.status}
            refetchFunction={refetchRequest}
          >
            <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
              <p className="text-lg font-bold">{initialEquipment?.display_name}</p>
              {initialEquipment?.fipe_code &&
                <div>
                  <p className="text-[14px] italic font-light">Código FIPE</p>
                  <p className="font-bold">{initialEquipment?.fipe_code}</p>
                </div>
              }
              <div className="flex gap-2">
                <TextField
                  label="Categoria"
                  disabled
                  data-testid="category_id_selector"
                  className="w-1/2"
                  value={initialEquipment?.category.display_name}
                />
                <TextField
                  label="Ano"
                  disabled
                  data-testid="year_input"
                  className="w-1/2"
                  value={`${initialEquipment?.year}`}
                />
              </div>
              <div className="flex gap-2">
                <TextField
                  label="Marca"
                  disabled
                  data-testid="brand_input"
                  className="w-1/2"
                  value={initialEquipment?.brand}
                />
                <TextField
                  label="Modelo"
                  disabled
                  data-testid="display_name_input"
                  className="w-1/2"
                  value={initialEquipment?.display_name}
                />
              </div>

              <TextField
                label="Porte"
                disabled
                data-testid="equipment_tier_input"
                value={initialEquipment?.equipment_tier?.display_name || ''}
              />

              <TextField
                label='Produtos e serviços aplicáveis'
                disabled
                data-testid="applicable_product_ids_selector"
                value={initialEquipment?.applicable_products.map((product) => product.display_name).join(', ')}
              />
            </Box>
          </ErrorMessageWrapper>
        )
      }
    </div>
  )
}

export default Show
